<template>
  <AppModal v-model="value" v-bind="$attrs" persistent max-width="500px" :disable-close="loading">
    <template v-slot:title>
      {{ title }}
    </template>
    <template v-slot:alert>
      <v-alert key="alert" outline class="my-0" type="error" :value="showAlert">
        <div class="primary--text">
          {{ alertMessage }}
        </div>
      </v-alert>
    </template>
    <template v-slot:text>
      <p>The alias {{synonymName}} will be created as a separate data source along with all specimen and survey data
        associated with it.</p>
      <v-checkbox color="info" v-model="assignToLocation" label="Assign to a location" persistent-hint hint="The alias will automatically be assigned to an existing or new location based on its name." :disabled="loading" />
      <ExecutionResultsDialog title="Alias Separation" @close="close()" :shouldClose="!loading" ref="executionResultsDialog" />
    </template>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn color="warning" :disabled="matchesLocationName" :loading="loading" @click="submit">
        <v-icon>call_split</v-icon>
        Separate
      </v-btn>
      <v-btn outline color="secondary" @click="close" :disabled="loading">
        {{ $t('Button.Cancel')}}
      </v-btn>
    </template>
  </AppModal>
</template>
<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const datasource = createNamespacedHelpers('datasource')
  const monitoringfeature = createNamespacedHelpers('monitoringfeature')
  const synonyms = createNamespacedHelpers('synonyms')
  const navigation = createNamespacedHelpers('navigation')

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  export default {
    props: {
      dataSourceIndex: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        value: false,
        loading: false,
        assignToLocation: true,
        synonymName: '',
      }
    },
    computed: {
      ...monitoringfeature.mapGetters(['currentMonitoringFeature']),
      title() {
        return `Separate alias ${this.synonymName}?`
      },
      showAlert() {
        return this.matchesLocationName
      },
      alertMessage() {
        return this.matchesLocationNameMessage
      },
      locationName() {
        return this.currentMonitoringFeature.DisplayName
      },
      matchesLocationName() {
        return this.locationName == this.synonymName
      },
      matchesLocationNameMessage() {
        return this.matchesLocationName ?
          'The alias cannot be separated from the data source because it matches the name of the alias\' assigned location' :
          null
      },
    },
    watch: {
      value() {
        if (!this.value) {
          this.reset()
        }
      },
    },
    methods: {
      ...synonyms.mapActions(['removeSynonym']),
      ...datasource.mapActions(['fetchDataSources']),
      ...monitoringfeature.mapActions(['refreshCurrentMFDetails', 'fetchMonitoringFeaturesUI']),
      ...navigation.mapActions(['fetchSideMenu']),
      show(synonymName) {
        this.synonymName = synonymName
        this.value = true
      },
      close() {
        this.value = false
        this.synonymName = ''
        this.reset()
      },
      reset() {
        this.loading = false
        this.assignToLocation = true
      },
      async submit() {
        this.loading = true
        try {
          const payload = {
            sourceId: this.dataSourceIndex.Id,
            synonymName: this.synonymName,
            sourceType: SOURCE_TYPES.vegetativeMonitoringEnvirodata,
            assignToLocation: this.assignToLocation,
          }
          let executionResults = await this.removeSynonym(payload)
          await this.refresh()
          this.$refs.executionResultsDialog.show(executionResults)
        } catch (err) {
          console.error('unmerge error', err)
          this.$refs.executionResultsDialog.show(err)
        } finally {
          this.loading = false
        }
      },
      async refresh() {
        const fetchIndicesPromise = this.fetchDataSources({
          sourceTypes: [SOURCE_TYPES.vegetativeMonitoringEnvirodata],
        })
        const fetchDetailsPromise = this.refreshCurrentMFDetails()
        const fetchAllMFsPromise = this.fetchMonitoringFeaturesUI()
        const fetchSideMenuPromise = this.fetchSideMenu()

        await Promise.all([fetchIndicesPromise, fetchDetailsPromise, fetchAllMFsPromise, fetchSideMenuPromise])
      },
    },
  }
</script>